import { useTranslation } from "react-i18next"
import type { MyBrandDrawerModel } from "../../lib/my-brand-drawer-model"

interface MetricCellProps {
  label: string
  value: string
  isLoading?: boolean
}

function MetricCell({ label, value, isLoading }: MetricCellProps) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <p className="text-[10px] font-normal uppercase tracking-[0.06em] text-muted-foreground">{label}</p>
      {isLoading ? (
        <div className="skeleton-shimmer-bar h-[19px] w-24 rounded" aria-hidden="true" />
      ) : (
        <p className="text-[13px] text-foreground">{value}</p>
      )}
    </div>
  )
}

interface DrilldownMyBrandCreativeMetricsGridProps {
  model: MyBrandDrawerModel
  isLoading?: boolean
}

export function DrilldownMyBrandCreativeMetricsGrid({
  model,
  isLoading = false,
}: DrilldownMyBrandCreativeMetricsGridProps) {
  const { t } = useTranslation()

  const cells: { label: string; value: string; queryBound?: boolean }[] = [
    { label: t("drilldown.myBrandDrawer.launchedDate", "Launched Date"), value: model.launchedDate },
    { label: t("drilldown.myBrandDrawer.spend", "Spend"), value: model.spend, queryBound: true },
    { label: t("drilldown.myBrandDrawer.duplications", "Duplications"), value: model.duplications, queryBound: true },
    { label: t("drilldown.myBrandDrawer.northStar", "North Star"), value: model.northStarValue, queryBound: true },
    { label: t("drilldown.myBrandDrawer.userPersona", "User Persona"), value: model.userPersona },
  ]

  return (
    <div className="rounded-[14px] border border-border bg-muted/50 p-4">
      <div className="grid grid-cols-2 gap-x-4 gap-y-5 sm:grid-cols-4">
        {cells.map((cell) => (
          <MetricCell
            key={cell.label}
            label={cell.label}
            value={cell.value}
            isLoading={isLoading && !!cell.queryBound}
          />
        ))}
      </div>
    </div>
  )
}
